import { PrismBanner } from '@mylighthouse/prism-ember';
import { t } from 'ember-intl';

<template>
  <PrismBanner
    @bannerMessage={{t "settings.my_otb.intro_page.message.non_admin_content"}}
    @bannerTitle={{t "settings.my_otb.intro_page.message.title"}}
  />
</template>
